// removed by extract-text-webpack-plugin
module.exports = {"verticalListBox":"verticalListBox--2e132"};